import { useContactTimeline } from "./useContactTimeline";
import { TimelineEntry } from "./TimelineEntry";
import { EmptyState } from "../shared/EmptyState";
import { Activity } from "lucide-react";

interface TimelineProps {
  contactId: string | undefined;
}

export function Timeline({ contactId }: TimelineProps) {
  const { data, isLoading, error } = useContactTimeline(contactId);

  if (isLoading) {
    return (
      <div style={{ padding: 24, textAlign: "center", color: "#9ca3af" }}>
        Loading timeline…
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 24, color: "#dc2626" }}>
        Failed to load timeline: {(error as Error).message}
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <EmptyState
        icon={<Activity size={32} />}
        title="No activity yet"
        description="Calls, messages, and notes will appear here."
      />
    );
  }

  return (
    <div style={{ maxHeight: 600, overflowY: "auto", padding: "0 4px" }}>
      {data.map((event) => (
        <TimelineEntry key={event.id} event={event} />
      ))}
    </div>
  );
}
